import { useId, type InputHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { Icon } from './Icon'
import styles from './Field.module.css'

export interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  readonly label: string
  readonly iconStart?: string | undefined
  readonly adornmentEnd?: ReactNode | undefined
  readonly error?: string | undefined
  readonly className?: string | undefined
}

export function Field({ label, iconStart, adornmentEnd, error, className, ...input }: FieldProps) {
  const id = useId()
  const errorId = `${id}-error`
  return (
    <div>
      <div className={cn(styles.field, error && styles.invalid, className)}>
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
        <div className={styles.control}>
          {iconStart && (
            <span className={styles.adornment}>
              <Icon name={iconStart} size={18} />
            </span>
          )}
          <input
            id={id}
            className={styles.input}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? errorId : undefined}
            {...input}
          />
          {adornmentEnd && <span className={styles.adornment}>{adornmentEnd}</span>}
        </div>
      </div>
      {error && (
        <p id={errorId} className={styles.error} role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
